import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import css from "./HomePage.module.css";
import RochaPerfil from "../../assets/RochaPerfil.png";
import Perfil from "../../assets/PerfilPro.png";
import whatsappLogo from "../../assets/whatsappLogo.png";
import { Head } from "../../Utils/Head";
import { Navbar } from "../Layout/Navbar";
import featureImage from "../../assets/feature_1.png";
import featureImage1 from "../../assets/feature_2.png";
import featureImage2 from "../../assets/feature_3.png";
import aboutImage from "../../assets/psychiatry.png";
import aboutImage1 from "../../assets/behaviour.png";
import ScrollToAnchor from "../../Utils/ScrollToAnchor";

export const HomePage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Head title="Home" description="Home - Mairini" />
      <div className={css.container}>
        <Navbar />

        <section className={css.featureInit}>
          <div className={css.heroContent}>
            <h1>
              Cuidar da mente é abrir espaço para viver com mais presença,
              clareza e propósito
            </h1>
            <button
              className={css.cvBtn}
              onClick={() =>
                window.open(
                  "https://api.whatsapp.com/send/?phone=556192492842&text=Ol%C3%A1+gostaria+de+marcar+uma+consulta&type=phone_number&app_absent=0",
                  "_blank"
                )
              }
            >
              Agendar consulta
            </button>
            <div>
              <h2>Thiago Rocha</h2>
              <p>Médico Psiquiatra</p>
            </div>
          </div>
        </section>

        <section className={css.hero}>
          <img src={Perfil} alt="" />
          <div className={css.heroId}>
            <h1>Thiago Rocha</h1>
            <p>CRM 26892 | RQE 21795</p>
          </div>
          <div className={css.featuresContainer}>
            <div className={css.featureCard}>
              <i className={`material-icons`}>public</i>
              <p>Atendimento online em todo Brasil</p>
            </div>
            <div className={css.featureCard}>
              <i className={`material-icons`}>schedule</i>
              <p>Horários flexíveis</p>
            </div>
            <div className={css.featureCard}>
              <i className={`material-icons`}>psychology</i>
              <p>Seguimento em psiquiatria e psicoterapia</p>
            </div>
          </div>
        </section>

        <section className={css.features1}>
          <div className={css.stepsContainer}>
            <div className={css.step1}>
              <h2>Atendimento Personalizado</h2>
              <p>
                Nosso atendimento parte do que é essencial em você - ajudando a
                construir um caminho de presença, clareza e compromisso com
                aquilo que realmente importa na sua vida.
              </p>
            </div>
            <div className={css.step1}>
              <h2>Abordagem Integrada</h2>
              <p>
                Oferecemos cuidado especializado para diversas condições de
                saúde mental, como depressão, ansiedade, pânico, TDAH, TOC,
                transtornos de personalidade e estresse pós-traumático (TEPT).
              </p>
            </div>
          </div>
        </section>

        <section className={css.features}>
          <button className={css.buttonMore} onClick={() => navigate("/about")}>
            Entenda mais sobre a abordagem terapêutica
          </button>
          {/* <h2>
            O acompanhamento foi pensado em te ajudar a responder, com
            profundidade
          </h2>
          <div className={css.stepsContainer}>
            <div className={css.step}>
              <p>Quem sou eu, além do que penso ou sinto?</p>
            </div>
            <div className={css.step}>
              <p>O que realmente importa para mim?</p>
            </div>
            <div className={css.step}>
              <p>Como posso lidar melhor com o sofrimento?</p>
            </div>
            <div className={css.step}>
              <p>Como posso viver com mais presença e intenção?</p>
            </div>
          </div> */}
          <h2>O que você vai encontrar</h2>
          <div className={css.stepsContainer}>
            <div className={css.step}>
              <p>
                Avaliação da personalidade para reconhecer seus traços
                predominantes
              </p>
            </div>
            <div className={css.step}>
              <p>
                Reflexão sobre valores pessoais, para identificar o que dá
                sentido à sua vida
              </p>
            </div>
            <div className={css.step}>
              <p>
                Práticas terapêuticas para desenvolver a habilidade de estar
                presente
              </p>
            </div>
          </div>
        </section>

        <section className={css.about}>
          <div className={css.aboutContainer}>
            <h1>Sobre</h1>
            <p>
              Thiago Rocha é professor da faculdade de medicina da Universidade
              de Brasília, mestre em ciências do comportamento pela UnB.
              Psiquiatra e preceptor do programa de residência médica em
              psiquiatria da Secretaria Estadual de Saúde do Distrito Federal.
              Possui residência médica em psiquiatria realizada no Hospital de
              Base do Distrito Federal, Graduado em medicina pela Escola
              Superior de Ciências da Saúde (ESCS).
            </p>
            <p>
              Atua com foco nas terapias comportamentais contextuais, como a
              Terapia de Aceitação e Compromisso (ACT) e a Psicoterapia
              Analítica Funcional (FAP). Seu trabalho clínico integra
              conhecimentos da psiquiatria e da psicologia contextual para
              oferecer um cuidado baseado em evidências, integral e
              personalizado.
            </p>
          </div>
          <img src={RochaPerfil} alt="" />
        </section>

        <section className={css.contact}>
          <h2>Entre em contato</h2>
          <i className={`material-icons`}>call</i>
          <button
            className={css.contactButton}
            onClick={() =>
              window.open(
                "https://api.whatsapp.com/send/?phone=556192492842&text=Ol%C3%A1+gostaria+de+marcar+uma+consulta&type=phone_number&app_absent=0",
                "_blank"
              )
            }
          >
            Envie uma mensagem
          </button>
        </section>

        <footer className={css.footer}>
          {/* <div className={css.footerLinks}>
            <a href="#">Privacidade</a>
            <a href="#">Termos de uso</a>
          </div> */}
          {/* <div className={css.footerSocial}>
            <a href="#">
              <ion-icon
                name="logo-facebook"
                className="icon"
                alt="Facebook"
              ></ion-icon>
            </a>
            <a href="#">
              <ion-icon
                name="logo-twitter"
                className="icon"
                alt="Twitter"
              ></ion-icon>
            </a>
            <a href="#">
              <ion-icon
                name="logo-linkedin"
                className="icon"
                alt="LinkedIn"
              ></ion-icon>
            </a>
          </div> */}
          <div className={css.footerContact}>
            {/* <p>Email: info@educationalplatform.com</p> */}
            {/* <p>Phone: +55 61 92492842</p> */}
          </div>
          <div className={css.newsletterSignup}>Mairini © 2025</div>
        </footer>
      </div>
    </>
  );
};
